import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import SyncIcon from '@mui/icons-material/Sync';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import { ActionButton } from "./components/ActionButton";
import CreateSupportTicketActionButton from "./components/CreateSupportTicketActionButton";
import { linkedItemFromWebshopCredentials } from "../../../../utils/supportTicketLinkedItems";
import { ActionIcon } from "./components/ActionIcon";
import Text from "../../../theme/text/Text";
import { Lock } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';

const AMWebshopCredentialsSp = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const colors = tokens(theme.palette.mode);

    const isFulfilment = props.isFulfilment;

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    // Check if the webshop is active - handle both 'active' boolean and 'state' string
    const isActive = props.webshopCredsData?.active === true || 
                     props.webshopCredsData?.active === 'true' ||
                     props.webshopCredsData?.state === 'active';

    const handleActivate = () => {
        props.onActivate();
        props.onClose();
    };

    const handleDeactivate = () => {
        props.onDeactivate();
        props.onClose();
    };

    const handleSync = () => {
        props.onSync();
        props.onClose();
    };

    const handleOAuth = () => {
        props.onOAuth();
        props.onClose();
    };

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding: 1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display: "flex",
                    gap: 1,
                    flexDirection: "column",
                    borderRadius: "24px",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    "@media screen and (max-width: 48em)": {
                        borderRadius: "32px",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    }
                }}
            >
                {isFulfilment && props.webshopCredsData && !isActive && (
                    <ActionButton onClick={handleActivate}>
                        <ActionIcon>
                            <PlayArrowIcon fontSize="small"/>
                        </ActionIcon>
                        <Box>
                            <Text>
                                {t('activate')}
                            </Text>
                        </Box>
                    </ActionButton>
                )}
                
                {isFulfilment && props.webshopCredsData && isActive && (
                    <ActionButton onClick={handleDeactivate}>
                        <ActionIcon>
                            <PauseIcon fontSize="small"/>
                        </ActionIcon>
                        <Box>
                            <Text>
                                {t('deactivate')}
                            </Text>
                        </Box>
                    </ActionButton>
                )}

                {props.webshopCredsData && (
                    <ActionButton onClick={handleSync}>
                        <ActionIcon>
                            <SyncIcon fontSize="small"/>
                        </ActionIcon>
                        <Box>
                            <Text>
                                {t('sync')}
                            </Text>
                        </Box>
                    </ActionButton>
                )}

                {props.webshopCredsData && (props.webshopCredsData.webshop_type === 'shopify' || props.webshopCredsData.webshop_type === 'bol') && (
                    <ActionButton onClick={handleOAuth}>
                        <ActionIcon>
                            <Lock fontSize="small"/>
                        </ActionIcon>
                        <Box>
                            <Text>
                                {t('reauthorize')}
                            </Text>
                        </Box>
                    </ActionButton>
                )}

                {props.webshopCredsData && (
                    <ActionButton onClick={() => props.onSyncOpen(true)}>
                        <ActionIcon>
                            <EditIcon fontSize="small"/>
                        </ActionIcon>
                        <Box>
                            <Text>
                                {t('order_sync_date')}
                            </Text>
                        </Box>
                    </ActionButton>
                )}
                <CreateSupportTicketActionButton
                    linkedItem={linkedItemFromWebshopCredentials(props.webshopCredsData)}
                    relationId={props.webshopCredsData?.relationId}
                    onClose={props.onClose}
                />
            </Box>
        </PopoverModal>
    );
};

export default AMWebshopCredentialsSp; 